import { useTranslation } from "react-i18next";
import { Alert, Text } from "@mantine/core";
import { IconAlertTriangle, IconInfoCircleFilled } from "@tabler/icons-react";
import i18n from "src/i18n";


export const getEnvBadgeName = (env: string) => {
  const names: Record<string, string> = {
    development: i18n.t("dev"),
    staging: i18n.t("staging"),
    production: i18n.t("prod"),
  };
  return names[env];
};

const badgeIcon: Record<string, React.ReactNode> = {
  development: <IconAlertTriangle color="var(--mantine-color-yellow-8)" />,
  staging: <IconInfoCircleFilled color="var(--mantine-color-blue-6)" />,
  production: <IconInfoCircleFilled color="var(--mantine-color-blue-6)" />,
};

export const EnvAlert = () => {
  const { t } = useTranslation();
  const env = import.meta.env.VITE_ENV_BADGE as string;

  if (env === "production") {
    return null;
  }

  return (
    <Alert
      mt="xl"
      variant="light"
      color={env === "development" ? "yellow" : "blue"}
      radius={"sm"}
      icon={badgeIcon[env]}
      title={
        <Text
          c={env === "development" ? "yellow.8" : "blue"}
          fw={500}
          fz={14}
          lh={1.5}>
          {getEnvBadgeName(env)}
        </Text>
      }>
      <Text fz={14} lh={1.5} c={env === "development" ? "yellow.8" : "blue"}>
        {t("env-message", { context: env })}
      </Text>
    </Alert>
  );
};
